import React, { Component } from "react";
import TextInput from "../FormComponents/TextInput/TextInput";
import DateInput from "../FormComponents/DateInput/DateInput";
import SelectInput from "../FormComponents/SelectInput/SelectInput";
import SwitchToggle from "../FormComponents/SwitchToggle/SwitchToggle";
import CheckInput from "../FormComponents/CheckInput/CheckInput";
import "./ContributorForm.less";
import SubmitButton from "../FormComponents/SubmitButton/SubmitButton";
import { PnpService } from "../../../services/pnp-service";
import { ApiService } from "../../../services/api-service";

class ContributorForm extends Component {
  constructor(props) {
    super(props);

    this.pnpService = new PnpService();
    this.apiService = new ApiService();

    this.state = {
      formData: {
        name: "",
        birthDate: "",
        documentType: "",
        documentNumber: "",
        phone: "",
        email: "",
        gender: "",
        compensationUser: false,
        complementaryPlan: false,
        category: "",
        termsAccepted: false,
        receiveEmail: false,
        receiveSms: false,
      },
      errors: {},
      documentOptions: [],
      selectedDocumentOption: null,
      categoryOptions: [],
      genderOptions: [],
    };
  }

  componentDidMount() {
    this.pnpService.getListByTitle(
      "tiposDocumento",
      (list) => {
        this.setState({
          documentOptions: list.map((documentType) => ({
            value: documentType.CSSiglaText,
            label: documentType.CSDocumentoIdentidadText,
            type: documentType.CSTipoChoice,
            length: documentType.CSLongitudNumber,
            range: documentType.CSRangoChoice
          })),
        });
      },
      "/salud"
    );

    this.pnpService.getListByTitle(
      "Categorias",
      (list) => {
        this.setState({
          categoryOptions: list.map((category) => ({
            value: category.CSTituloCategoriaText,
            label: category.Title,
          })),
        });
      },
      "/salud"
    );

    this.pnpService.getListByTitle(
      "Genero",
      (list) => {
        this.setState({
          genderOptions: list.map((gender) => ({
            value: gender.Title,
            label: gender.Title,
          })),
        });
      },
      "/salud/medicina-prepagada"
    );
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let errorMessage = "";

    // Validaciones específicas para ciertos campos
    if (name === "name") {
      const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
      if (!nameRegex.test(value)) {
        errorMessage = "Solo se permiten letras y espacios.";
      }
    }

    if (name === "documentType") {
      const selectedOption = this.state.documentOptions.find(
        (opt) => opt.value === value
      );

      let birthDateError = "";

      if (this.state.formData.birthDate && selectedOption) {
        const birthDate = new Date(this.state.formData.birthDate);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        const d = today.getDate() - birthDate.getDate();
        const adjustedAge = m < 0 || (m === 0 && d < 0) ? age - 1 : age;

        if (selectedOption.range === "Mayores" && adjustedAge < 18) {
          birthDateError = "Debe ser mayor de edad.";
        } else if (selectedOption.range === "Menores" && adjustedAge >= 18) {
          birthDateError = "Debe ser menor de edad.";
        }
      }

      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value || "",
          documentNumber: "", // limpiar número si se cambia el tipo
        },
        selectedDocumentOption: selectedOption,
        errors: {
          ...prevState.errors,
          [name]: value.trim() === "" ? "Este campo es obligatorio" : "",
          birthDate: birthDateError,
          documentNumber: "", // limpiar errores también
        },
      }));
    }


    if (name === "documentNumber") {
      const { selectedDocumentOption } = this.state;
      if (!selectedDocumentOption) return;

      const maxLength = selectedDocumentOption.length;
      const type = selectedDocumentOption.type; // Ej: "NUMERICO" o "ALFA"

      if (value.length > maxLength) {
        errorMessage = `El número de documento no puede superar los ${maxLength} caracteres.`;
      } else if (type === "NUMERICO" && !/^[0-9]*$/.test(value)) {
        errorMessage = "Solo se permiten números.";
      } else if (type === "ALFA" && !/^[a-zA-Z0-9]*$/.test(value)) {
        errorMessage = "Solo se permiten letras y números.";
      }
    }

    if (name === "birthDate") {
      const { selectedDocumentOption } = this.state;

      if (selectedDocumentOption) {
        const range = selectedDocumentOption.range;
        const birthDate = new Date(value);
        const today = new Date();

        const age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        const d = today.getDate() - birthDate.getDate();

        // Calcular edad exacta (si no ha cumplido años aún)
        const adjustedAge = m < 0 || (m === 0 && d < 0) ? age - 1 : age;

        if (range === "Mayores" && adjustedAge < 18) {
          errorMessage = "Debe ser mayor de edad.";
        } else if (range === "Menores" && adjustedAge >= 18) {
          errorMessage = "Debe ser menor de edad.";
        }
      }
    }

    if (name === "phone") {
      const phoneRegex = /^[0-9+]+$/;
      if (!phoneRegex.test(value)) {
        errorMessage = "Solo se permiten números y el símbolo '+'.";
      }
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        errorMessage = "Ingresa un correo electrónico válido.";
      }
    }

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value || "",
      },
      errors: {
        ...prevState.errors,
        [name]: errorMessage || (value.trim() === "" ? "Este campo es obligatorio" : ""),
      },
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { formData, errors } = this.state;

    // Lista de campos requeridos
    const requiredFields = [
      "name",
      "birthDate",
      "documentType",
      "documentNumber",
      "phone",
      "email",
      "gender",
      "category",
    ];

    let newErrors = { ...errors };
    let isValid = true;

    // Verificar si hay errores de validación previos
    Object.keys(errors).forEach((field) => {
      if (errors[field]) {
        isValid = false;
      }
    });

    // Verificar que todos los campos requeridos estén llenos
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "Este campo es obligatorio";
        isValid = false;
      }
    });

    // Verificar que los términos y condiciones fueron aceptados
    if (!formData.termsAccepted) {
      newErrors.termsAccepted = "Debes aceptar los términos y condiciones";
      isValid = false;
    }

    // Si hay errores, actualizar el estado y no enviar el formulario
    if (!isValid) {
      this.setState({ errors: newErrors });
      return;
    }

    // Si todo está correcto, proceder con el envío
    const body = {
      NombreCompleto: formData.name,
      TipoDocumento: formData.documentType,
      NumeroDocumento: formData.documentNumber,
      Telefono: formData.phone,
      Email: formData.email,
      AutorizaTratamientoDatos: formData.termsAccepted,
      AceptaRecibirInformacion: formData.receiveEmail,
      AceptaMensajes: formData.receiveSms,
      FechaNacimiento: formData.birthDate,
      Genero: formData.gender,
      IsCajaCompensacion: formData.compensationUser,
      IsPlanComplementario: formData.complementaryPlan,
      CategoriaCajaCompensacion: formData.category,
    };

    this.apiService
      .post("ServicioConsorcio.svc/GuardarCotizacionMP", body)
      .then((result) => {
        console.log("Formulario enviado con éxito", result);
        if (this.props.onContributorChange) {
          this.props.onContributorChange({ ...this.state.formData });
        }

        if (this.props.onCotizationChange) {
          this.props.onCotizationChange(result.IdCotizacion);
        }
      })
      .catch((error) => {
        console.error("Error al enviar el formulario:", error.message);
      });
  };

  render() {
    const { formData, errors } = this.state;
    return (
      <form className="contributor-form" onSubmit={this.handleSubmit}>
        <div className="container-grid">
          <div className="form-group">
            <TextInput
              label="Nombre"
              name="name"
              value={formData.name}
              onChange={this.handleChange}
              required
              error={errors.name}
            />
          </div>
          <div className="form-group">
            <DateInput
              label="Fecha de nacimiento"
              name="birthDate"
              value={formData.birthDate}
              onChange={this.handleChange}
              required
              error={errors.birthDate}
            />
          </div>
          <div className="form-group">
            <SelectInput
              label="Tipo de documento"
              name="documentType"
              value={formData.documentType}
              onChange={this.handleChange}
              options={this.state.documentOptions}
              required
              error={errors.documentType}
            />
          </div>
          <div className="form-group">
            <TextInput
              label="Número de documento"
              name="documentNumber"
              value={formData.documentNumber}
              onChange={this.handleChange}
              required
              error={errors.documentNumber}
              disabled={!this.state.formData.documentType}
            />
          </div>
          <div className="form-group">
            <TextInput
              label="Teléfono móvil"
              name="phone"
              value={formData.phone}
              onChange={this.handleChange}
              required
              error={errors.phone}
            />
          </div>
          <div className="form-group">
            <TextInput
              label="Correo electrónico"
              name="email"
              type="email"
              value={formData.email}
              onChange={this.handleChange}
              required
              error={errors.email}
            />
          </div>
          <div className="form-group">
            <SelectInput
              label="Género"
              name="gender"
              value={formData.gender}
              onChange={this.handleChange}
              options={this.state.genderOptions}
              required
              error={errors.gender}
            />
          </div>
        </div>
        <div className="switch-group mt-2">
          <span>
            ¿Eres usuario de <b>Caja de compensación Compensar</b>?
          </span>
          <SwitchToggle
            name="compensationUser"
            checked={formData.compensationUser}
            onChange={this.handleChange}
            labelOff="No"
            labelOn="Sí"
          />
        </div>
        <div className="switch-group mt-2">
          <span>
            ¿Actualmente cuentas con un <b>Plan Complementario de Compensar</b>?
          </span>
          <SwitchToggle
            name="complementaryPlan"
            checked={formData.complementaryPlan}
            onChange={this.handleChange}
            labelOff="No"
            labelOn="Sí"
          />
        </div>
        <div className="container-grid mt-2">
          <div className="form-group">
            <SelectInput
              label="Categoría caja de compensación"
              name="category"
              value={formData.category}
              onChange={this.handleChange}
              options={this.state.categoryOptions}
              required
              error={errors.category}
            />
          </div>{" "}
        </div>
        <hr className="divider-dashed mt-2" />
        <div className="mt-2">
          <SwitchToggle
            name="selectAllTerms"
            checked={
              formData.termsAccepted &&
              formData.receiveEmail &&
              formData.receiveSms
            }
            onChange={(e) => {
              const { checked } = e.target;
              if (checked) {
                this.setState((prevState) => ({
                  ...prevState,
                  formData: {
                    ...prevState.formData,
                    termsAccepted: true,
                    receiveEmail: true,
                    receiveSms: true,
                  },
                }));
              }
            }}
            labelOn="Seleccionar todo"
          />
        </div>
        <div className="mt-2">
          <CheckInput
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={this.handleChange}
            label="Autorización de tratamiento de los datos personales."
          />
          <CheckInput
            name="receiveEmail"
            checked={formData.receiveEmail}
            onChange={this.handleChange}
            label="Acepto recibir información de Compensar en mi correo electrónico."
          />
          <CheckInput
            name="receiveSms"
            checked={formData.receiveSms}
            onChange={this.handleChange}
            label="Acepto recibir mensajes de texto en mi celular con información de Compensar. (Sin costo)"
          />
        </div>
        <br />
        <SubmitButton>
          <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
          Continuar
        </SubmitButton>
      </form>
    );
  }
}

export default ContributorForm;
